(function () {
  const form = document.getElementById('pz-form');
  if (!form) return;

  const chosenMain = document.querySelector('.pz-chosen__main');
  document.querySelectorAll('.pz-chosen__thumb').forEach((thumb, _, all) => {
    thumb.addEventListener('click', () => {
      chosenMain.src = thumb.dataset.src;
      all.forEach((t) => t.removeAttribute('aria-current'));
      thumb.setAttribute('aria-current', 'true');
    });
  });

  const FIELDS = ["Child's name", 'Age', 'Party date', 'Party time', 'Party place', 'RSVP', 'Notes'];
  const LABELS = {
    "Child's name": 'Name',
    Age: 'Age',
    'Party date': 'Date',
    'Party time': 'Time',
    'Party place': 'Place',
    RSVP: 'RSVP',
    Notes: 'Notes',
  };
  const etsy = form.dataset.etsy === 'true';
  if (etsy) {
    FIELDS.unshift('Etsy order number');
    LABELS['Etsy order number'] = 'Etsy order number';
    if (form.elements.namedItem('Canva link')) {
      FIELDS.push('Canva link');
      LABELS['Canva link'] = 'Canva link';
    }
  }
  const EMOJI = /[\p{Extended_Pictographic}\u{FE0F}\u{200D}]/gu;
  const list = form.querySelector('.pz-card__list');
  const empty = form.querySelector('.pz-card__empty');
  const errorBox = form.querySelector('.pz-error');
  const submit = form.querySelector('.pz-submit');
  const serviceOn = form.dataset.service === 'true';

  const input = (name) => form.elements.namedItem(name);
  const clean = (s) => s.replace(EMOJI, '').replace(/\s+/g, ' ').trim();
  const phoneBox = form.querySelector('.pz-phone');
  const phone = input('Phone');
  const emailNote = form.querySelector('.pz-contact-email');
  // Print: checked pack radio. Digital: one hidden input with the single variant.
  const getPack = () =>
    form.querySelector('input[name="pz-pack"][type="radio"]:checked:not(:disabled)') ||
    form.querySelector('input[name="pz-pack"][type="hidden"]');
  const checkedValue = (name) => {
    const el = form.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  };
  const contactBy = () => checkedValue('Contact by') || 'Email';

  function addRow(term, value) {
    const dt = document.createElement('dt');
    dt.textContent = term;
    const dd = document.createElement('dd');
    dd.textContent = value;
    list.append(dt, dd);
  }

  function render() {
    list.textContent = '';
    let any = false;
    FIELDS.forEach((name) => {
      const v = clean(input(name).value);
      if (!v) return;
      any = true;
      addRow(LABELS[name], v);
    });
    const pack = getPack();
    if (pack && form.dataset.mode === 'print') addRow('Pack', pack.dataset.label);
    if (pack && serviceOn && submit.dataset.template && pack.dataset.price) {
      submit.textContent = submit.dataset.template.replace('{count}', pack.dataset.count).replace('{price}', pack.dataset.price);
    }
    addRow('Proof', checkedValue('Proof'));
    const by = contactBy();
    addRow('Contact', by === 'Email' ? 'Email' : by + (clean(phone.value) ? ', ' + clean(phone.value) : ''));
    phoneBox.hidden = by === 'Email';
    phone.required = by !== 'Email';
    emailNote.hidden = by !== 'Email';
    empty.hidden = any;
    form.querySelectorAll('.pz-count').forEach((c) => {
      const el = input(c.dataset.for);
      c.textContent = el.value.length + ' / ' + el.maxLength;
    });
  }

  function validate() {
    const problems = [];
    form.querySelectorAll('.pz-input').forEach((el) => el.removeAttribute('aria-invalid'));
    FIELDS.forEach((name) => {
      const el = input(name);
      const v = clean(el.value);
      if (el.required && !v) {
        problems.push(LABELS[name] + ' is empty');
        el.setAttribute('aria-invalid', 'true');
      } else if (v.length > el.maxLength) {
        problems.push(LABELS[name] + ' is too long');
        el.setAttribute('aria-invalid', 'true');
      }
    });
    if (etsy) {
      const order = input('Etsy order number');
      const digits = order.value.replace(/\D/g, '');
      if (order.value.trim() && (digits.length < 6 || digits.length > 15)) {
        problems.push('Etsy order number should contain 6 to 15 digits');
        order.setAttribute('aria-invalid', 'true');
      }
    }
    if (contactBy() !== 'Email') {
      const digits = phone.value.replace(/\D/g, '');
      if (digits.length < 7 || digits.length > 15) {
        problems.push('Mobile number looks incomplete');
        phone.setAttribute('aria-invalid', 'true');
      }
    }
    if (!getPack()) problems.push('Choose a pack');
    if (!input('pz-confirm').checked) problems.push('Tick the box to confirm you checked the text');
    return problems;
  }

  function showError(text) {
    errorBox.textContent = text;
    errorBox.hidden = !text;
  }

  form.addEventListener('input', render);
  form.addEventListener('change', render);
  render();

  form.addEventListener('submit', async (evt) => {
    evt.preventDefault();
    const problems = validate();
    if (problems.length) {
      showError(problems.join('. ') + '.');
      const bad = form.querySelector('[aria-invalid="true"]');
      if (bad) bad.focus();
      return;
    }
    showError('');
    if (!serviceOn) {
      showError('This is a preview. This service is not on sale yet.');
      return;
    }
    const pack = getPack();
    if (!pack || !pack.value) {
      showError('This service is not available right now. Please email us.');
      return;
    }
    const properties = etsy ? {} : { Design: form.dataset.designTitle };
    FIELDS.forEach((name) => {
      const v = clean(input(name).value);
      if (v) properties[name] = v;
    });
    if (etsy) properties['Etsy order number'] = input('Etsy order number').value.replace(/\D/g, '');
    properties.Proof = checkedValue('Proof');
    properties['Contact by'] = contactBy();
    if (contactBy() !== 'Email') properties.Phone = clean(phone.value);
    if (!etsy) {
      properties._design_handle = form.dataset.designHandle;
      properties._design_sku = form.dataset.designSku;
    }

    const label = submit.textContent;
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    submit.textContent = 'Adding to cart…';
    try {
      const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(pack.value), quantity: 1, properties }] }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      window.location.href = window.routes && routes.cart_url ? routes.cart_url : '/cart';
    } catch (e) {
      showError(e.message + '. Please try again or email us.');
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
      submit.textContent = label;
    }
  });
})();
